"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.radius = exports.size = void 0;
const utils_1 = require("@icr-ui/utils");
const spacings_1 = __importDefault(require("./spacings"));
exports.size = {
    default: '1px solid',
};
exports.radius = {
    alert: (0, utils_1.pxToRem)(8.8),
    button: (0, utils_1.pxToRem)(50),
    cardButton: spacings_1.default.s2,
    card: spacings_1.default.s2,
    input: spacings_1.default.s3,
    dropdown: (0, utils_1.pxToRem)(13.008),
    tag: spacings_1.default.s6,
    round: '50%',
    full: '100%',
};
const borders = {
    size: exports.size,
    radius: exports.radius,
};
exports.default = borders;
//# sourceMappingURL=borders.js.map